import styled from "styled-components";
import {UnderTopBarFloater} from "../../../../AppStyle";
import {ProposalBoxAddressLabel} from "../../../../Address/AddressesStyle";

export const SuggestionsFloater = styled.div`
    ${UnderTopBarFloater};
    max-width: 90%;
    right: 5%;
    left: 5%;
    overflow: hidden;
    font-weight: 300;
    padding: 0;
`;

export const SuggestionTitleContainer = styled.div`
    width: 100%;
    height: 29px;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
`;

export const SuggestionsTitle = styled.label`
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    color: #808080;
    font-weight: 600;
    margin-left: 10px;
    margin-right: 10px;
`;

export const SuggestionRow = styled.div`
    display: flex;
`;

export const SuggestionRowAddress = ProposalBoxAddressLabel.extend`
    font-size: 15px;
    color: #555555
`;


// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/FreeSelection/AddressSearch/AddressSearchStyle.js